import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';

import insightPurchaseImage from '../../assets/completed-steps-animate.svg';
import Button from '../../components/inputs/Button';
import { FILES_QUERY } from '../../queries';
import ErrorText from '../../components/ErrorText';
import { isIdFile } from '../../helpers/fileKinds';

export default function PurchasePrompt() {
  const navigate = useNavigate();

  const { fileId } = useParams();
  const [matchedFile, setMatchedFile] = useState(null);

  const { loading, error, data } = useQuery(FILES_QUERY, {
    fetchPolicy: 'cache-and-network',
  });
  const files = data?.files;

  useEffect(() => {
    function navigateToMyWorkFiles() {
      navigate('../../../mywork/files');
    }
    if (error) {
      navigateToMyWorkFiles();
    }
    if (!loading && files && files?.length) {
      // ATAD-136/ATAD-146: ZIP code and model files have no matched records
      // to profile.
      const foundInFiles = files.find(
        (file) => fileId === file.id && isIdFile(file)
      );
      if (!foundInFiles) {
        navigateToMyWorkFiles();
      }
      setMatchedFile(foundInFiles);
    }
  }, [error, fileId, loading, files, navigate]);

  return (
    <div className="w-full h-full flex flex-col overflow-hidden justify-center items-center">
      <div className="flex items-center mb-8">
        <img
          className="h-80 mx-auto"
          src={insightPurchaseImage}
          alt="one out of six light bulbs lit up"
        />
      </div>
      <p className="mt-1">
        File name for profile report:{' '}
        <span className="font-bold">{matchedFile?.name}</span>
      </p>
      <div className="flex flex-col items-center gap-8 mb-24 mt-8">
        <Link
          to="../order"
          state={{
            orderDetails: {
              coreProductName: 'measurementReport',
              fileName: matchedFile?.name,
              fileId: matchedFile?.id,
              matchedRecords: matchedFile?.numMatchedRecords,
            },
          }}
        >
          <Button type="button" primary disabled={matchedFile?.hasBeenProfiled}>
            Generate Profile Report
          </Button>
        </Link>
        {matchedFile?.hasBeenProfiled && (
          <ErrorText message="You have already purchased a profile report for this file." />
        )}
      </div>
    </div>
  );
}
